import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(protected http: HttpClient) { }

  find(query?): Observable<any[]> {
    return this.http.get<any[]>(`customers`, { params: query });
  }
}
